/**
 * Module for hidden marketo field that takes the value of the Google Analytics generated id and passes it to marketo
 * for GA session deanonymizing purposes 
 */

 let gaGUID = null;
 const guidLoadedCallbacks = [];

//get the GA client id
//https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#getting_the_client_id_from_the_cookie
function init(timoutAttemptsLeft){
    //sanity check since ga might not be loaded yet
    //unfortunately only way to wait for GA is continually setting timeouts
    //https://stackoverflow.com/questions/1954910/javascript-detect-if-google-analytics-is-loaded-yet
    if(!window.ga){
        if(timoutAttemptsLeft > 0){
            setTimeout(()=>{
                init(timoutAttemptsLeft - 1);
            }, 2000);
        }
        return;
    }
    ga((tracker) => {
        gaGUID = tracker.get('clientId');

        guidLoadedCallbacks.forEach((callback)=>{
            callback(gaGUID);
        });
    });
}

init(10);

//name of field that is sent to marketo
export const MARKETO_GA_GUID_FIELD_NAME = 'Google_Analytics_Client_ID__c';

//sync version when gaGUID is set on form submit
//getting the client id is technically asynchronous if GA is not loaded already, but 
// 1. GA should already be loaded by this time
// 2. If GA is slow to load or doesn't load we should not block marketo form submissions waiting for it
export function getGaGuid(){
    return gaGUID;
}

//async version for when gaGUID is set on page load
export function getGaGuidAsync(callback){
    if(gaGUID === null){
        guidLoadedCallbacks.push(callback);
    }
    else{
        callback(gaGUID);
    }
}